import styled from "styled-components";

const Form = styled.form`
  background-color: var(--color-white);
  border-radius: 2.5rem;
  width: 54rem;
  padding-bottom: 3.4rem;
  position: relative;
  @media screen and (max-width: 31em) {
    width: 32.7rem;
  }
`;

export default Form;
